import {combineReducers} from 'redux';
import user from './userReducer';
import routesPermissions from './routesPermissionsReducer';
import auth from './authReducer';
import contractInfo from './contractInfoReducer'
import teacherInfo from './teacherInfoReducer'

import ajaxCallsInProgress from './ajaxStatusReducer';
import { routerReducer } from 'react-router-redux';


const rootReducer = combineReducers({
  routing: routerReducer,
  routesPermissions,
  user,
  auth,
  ajaxCallsInProgress,
  contractInfo,
  teacherInfo
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js